// For PaginateSelect search in Tariff dropdown

import {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import { useAtom } from "jotai";
import OutageLoadManagement from "../gridParameter/outageLoadManagement";
import OpexCapex from "../gridParameter/opexCapex";
import GridPowerExchange from "../gridParameter/gridPowerExchange";
import MGAAPI from "../../../api/index";
import displayError from "../../../constants/utils";
import {
  flattenCountComponentDTOList,
  flattenDesignCountComponent,
  projectDetailsAtom,
} from "../../../utils/atoms/projectDetailsAtom";
import { componentsAtom } from "../../../utils/atoms/componentsAtom";
import "../../../components/sideMenu/style.scss";
import Tariff from "../../../Tarrif/Tariff";
import { AccordionItem } from "../../AccordianItem";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCompress, faExpand } from "@fortawesome/free-solid-svg-icons";
import { useForm } from "@mantine/form";
import _, { get, set } from "lodash";
import AlertIcon from "../../Alert";
import {
  Tabs,
  useMantineColorScheme,
  Grid,
  Select,
  TextInput,
  Text,
  Card,
  Transition,
  Button,
  LoadingOverlay,
  Group,
  SegmentedControl,
  Switch,
  Textarea,
  FileInput,
  Radio,
  Divider,
} from "@mantine/core";
import { IconCaretDownFilled, IconFileSearch } from "@tabler/icons-react";
import { addedStepsAtom } from "../../../utils/atoms/addedStepsAtom";
import startDateAtom from "../../../utils/atoms/startDateAtom"; // baseline start date for validation
import { componentStatusAtom } from "../../../utils/atoms/componentStatus";
import { helpAtom } from "../../../utils/atoms/helpAtom";
import gridJson from "../../../components/help/helpCardMenu.json";
import { mgaRegex, responsiveCol, useAssessmentRouteParams, useCurrentDesignComponentLists, useCurrentDesignVersion, isNullOrWhitespace, TICKET_TYPE_OPTIONS, sanitizeText } from "../../../constants/helper";
import { formatProjectNumberRange } from "../../../utils/helpers";
import { serializeOutageDates } from "../gridParameter/outageLoadManagement/outageLoad.constants";

import PropTypes from "prop-types";
import DynamicTariffImport from "./DynamicTariffImport";
import { DCTariff } from "../../../DemandCharge/DCTariff";
import DemandCharge from "../../../DemandCharge";
import PaginateSelect from "../../PaginateSelect";
import { useHelpFocusBlur } from "../../../utils/useHelpFocusBlur";
import { getErrorMessage } from "../../../utils/errorUtils";
import { useTranslation } from "react-i18next";
import TariffRawTable from "../TariffRawTable";
import SEConfirmModal from "../../common/SEConfirmModal";
import { helpContextMenuAtom } from "../../../utils/atoms/helpContextMenuAtom";
import { userScopeAtom } from "../../../utils/atoms/userScopeAtom";

const GENABILITY_COUNTRIES = [
  "United States",
  "Puerto Rico",
  "Canada",
  "Mexico",
  "États-Unis"
];

const MGA_API = new MGAAPI();
const LoadGrid = forwardRef((props, ref) => {
  const { t } = useTranslation();
  const {
    tariffRef,
    tariffEnergyRef,
    setLoadingComp,
    tariffTouRef,
    loadingComp,
    dcTariffRef,
    dcGenabilityTariffRef,
  } = props;
  const [addedStepsSeries] = useAtom(addedStepsAtom);
  const [projectComponents, setProjectComponents] = useAtom(componentsAtom);
  const [isFullSize, setIsFullSize] = useState(false);
  const [gridParameters, setGridParameters] = useState({});
  const [projectDetails, setProjectDetails] = useAtom(projectDetailsAtom);
  const numberFormat = projectDetails?.projectDTO?.numberFormat;
  const formatRange = (min, max) =>
    formatProjectNumberRange(min, max, numberFormat);
  const { designId, designVersionId, projectId } = useAssessmentRouteParams();
  const selectedDesignAndDesignVersion = useCurrentDesignComponentLists(projectDetails?.designComponentsList);
  const isNewGrid = !selectedDesignAndDesignVersion.componentDTOList.some(
    (component) => component.componentType === "Grid",
  );
  const selectedVersion = useCurrentDesignVersion(projectDetails?.designWithVersionsDTOList);

  const [userScope] = useAtom(userScopeAtom);
  const [, setComponentStatus] = useAtom(componentStatusAtom);
  const [helperAtom, setHelperAtom] = useAtom(helpAtom);
  const [electricityTariffSelected, setElectricityTariffSelected] =
    useState("static");
  const transitionContainerRef = useRef(null);
  const [selectedDemandCard, setSelectedDemandCard] = useState(0); // 0: Fixed, 1: Subscribed, 2: Ratchet, 3: ToU
  const [activeTab, setActiveTab] = useState("energy_import");
  // Modal state for country error
  const [showCountryError, setShowCountryError] = useState(false);
  const [tariffOptions, setTariffOptions] = useState([]);
  const [tariffLoading, setTariffLoading] = useState(false);
  const [importAttempted, setImportAttempted] = useState(false);
  const { colorScheme } = useMantineColorScheme();
  const [alert, setAlert] = useState({
    message: "",
    alertPopUpStatus: false,
    title: "",
  });
  const [genabilityListItem, setGenabilityListItem] = useState(null);
  const [genabilityStale, setGenabilityStale] = useState(false);
  const [customerClass, setCustomerClass] = useState("GENERAL");
  const [isSingleGenabilityDropdownShown, setIsSingleGenabilityDropdownShown] =
    useState(false);
  const [selectedTariffData, setSelectedTariffData] = useState({
    staticTariff: null,
    genabilityTariff: null,
  });
  const [selectedTariffRaw, setSelectedTariffRaw] = useState(null);
  const [showHelpModal, setShowHelpModal] = useState(false);
  const [helpForm, setHelpForm] = useState({
    ticketType: "TARIFF_REVIEW",
    ticketTitle: "",
    ticketDesc: "",
    file: null,
  });
  const [helpSubmitting, setHelpSubmitting] = useState(false);
  const [helpErrors, setHelpErrors] = useState({
    ticketType: "",
    ticketTitle: "",
    ticketDesc: "",
  });

  const resetHelpForm = () => {
    setHelpForm({
      ticketType: "TARIFF_REVIEW",
      ticketTitle: "",
      ticketDesc: "",
      file: null,
    });
    setHelpErrors({ ticketType: "", ticketTitle: "", ticketDesc: "" });
  };

  // Tariff template state
  const [tariffTemplateNames, setTariffTemplateNames] = useState([]);
  const [selectedTemplateName, setSelectedTemplateName] = useState(null);
  const [templateSaveLoading, setTemplateSaveLoading] = useState(false);
  const [templateNameInput, setTemplateNameInput] = useState("");
  const [templateNameModalOpen, setTemplateNameModalOpen] = useState(false);
  const [templateNameError, setTemplateNameError] = useState("");
  const [templateAlteredModalOpen, setTemplateAlteredModalOpen] = useState(false);
  const skipTemplateCheckRef = useRef(false);
  const templateTariffDirtyRef = useRef(false);

  // Template picker modal state
  const [showTemplatePickerModal, setShowTemplatePickerModal] = useState(false);
  const [templatePickerSelected, setTemplatePickerSelected] = useState(null);
  const [templatePickerLoading, setTemplatePickerLoading] = useState(false);
  const [showDeleteTemplateModal, setShowDeleteTemplateModal] = useState(false);
  const [deleteTemplateId, setDeleteTemplateId] = useState(null);
  const [deleteTemplateLoading, setDeleteTemplateLoading] = useState(false);
  const [deleteTemplateName, setDeleteTemplateName] = useState("");

  const handleOpenTemplatePicker = (e) => {
    e.preventDefault();
    setTemplatePickerSelected(null);
    setShowTemplatePickerModal(true);
  };

  const handleTemplatePickerConfirm = () => {
    if (templatePickerSelected) {
      setTemplatePickerLoading(true);
      handleTemplateSelect(templatePickerSelected, () => {
        setTemplatePickerLoading(false);
        setShowTemplatePickerModal(false);
      });
    } else {
      setShowTemplatePickerModal(false);
    }
  };

  // Note: there is already a useEffect watching electricityTariffSelected (line ~912) for resetting dynamic data
  useEffect(() => {
    if (electricityTariffSelected !== "static") return;
    if (!userScope?.access?.myTariffTemplates) return;
    MGA_API.getMyTariffTemplates()
      .then((res) => {
        if (Array.isArray(res)) setTariffTemplateNames(res);
      })
      .catch((error) => {
        displayError("error", getErrorMessage(error) || "Failed to load tariff templates");
      });
  }, [electricityTariffSelected, userScope]);

  const handleTemplateSelect = (id, onDone) => {
    setSelectedTemplateName(id);
    if (!id) {
      templateTariffDirtyRef.current = false;
      onDone?.();
      return;
    }
    const templateItem = tariffTemplateNames?.find((t) => String(t?.id) === String(id));
    if (!templateItem) { onDone?.(); return; }
    MGA_API.getTariffTemplate(templateItem?.id)
      .then((res) => {
        if (res) {
          setSelectedTariffData((prev) => ({
            ...prev,
            staticTariff: {
              ...(prev?.staticTariff || {}),
              tariffParameters: {
                ...(prev?.staticTariff?.tariffParameters || {}),
                energy: res?.template?.energy ?? prev?.staticTariff?.tariffParameters?.energy,
                export: res?.template?.export ?? prev?.staticTariff?.tariffParameters?.export,
              },
            },
          }));
          setGridParameters((prev) => ({
            ...prev,
            componentAttributes: {
              ...(prev?.componentAttributes || {}),
              tariffParameters: {
                ...(prev?.componentAttributes?.tariffParameters || {}),
                ...(res?.template?.energy ? { energy: res.template.energy } : {}),
                ...(res?.template?.export ? { export: res.template.export } : {}),
                ...(res?.template?.demandCharge ? { demandCharge: res.template.demandCharge } : {}),
              },
            },
          }));
          // Templates always store generic (ToU) configuration. Switch import/export back to
          // generic mode so the correct UI and values are displayed after template load.
          setIsStaticTimeSeriesUpload({ energy: false, export: false });
          setDynamicGraphDataForStatic({ energy: null, export: null });
          handleTariffChange();
          // Reset dirty flag — template was just loaded, user hasn't changed anything yet
          templateTariffDirtyRef.current = false;
        }
        onDone?.();
      })
      .catch((error) => {
        displayError("error", getErrorMessage(error) || "Failed to load tariff template");
        onDone?.();
      });
  };

  const handleSaveAsTemplate = () => {
    const templateItem = tariffTemplateNames?.find((t) => String(t?.id) === String(selectedTemplateName));
    setTemplateNameInput(templateItem?.templateName || "");
    setTemplateNameError("");
    setTemplateNameModalOpen(true);
  };

  const handleTemplateSaveConfirm = () => {
    if (!templateNameInput?.trim()) return;

    if (templateNameInput.trim().length > 100) {
      setTemplateNameError(t("grid.tariffTemplate.nameTooLong"));
      return;
    }

    // Block save if the name already exists in the dropdown list
    const isDuplicate = tariffTemplateNames?.some((t) => t?.templateName === templateNameInput?.trim());
    if (isDuplicate) {
      setTemplateNameError(t("grid.tariffTemplate.duplicateNameError"));
      return;
    }
    setTemplateNameError("");

    // If energy/export are in Dynamic Configuration, they cannot be saved as a template (set to null)
    let energySeason = null;
    if (!isStaticTimeSeriesUpload?.energy) {
      const energyValidation = tariffRef?.current?.handleValidate();
      if (energyValidation?.error) {
        setActiveTab("energy_import");
        return;
      }
      energySeason = energyValidation?.data ?? null;
    }

    let exportSeason = null;
    const isExportEnabled =
      gridParameters?.componentAttributes?.gridParameters?.powerExport?.condition !==
      "No Export";
    if (isExportEnabled && !isStaticTimeSeriesUpload?.export) {
      const exportValidation = tariffEnergyRef?.current?.handleValidate();
      if (exportValidation?.error) {
        setActiveTab("account");
        return;
      }
      exportSeason = exportValidation?.data ?? null;
    }

    const dcValidation = dcTariffRef?.current?.handleValidate();
    if (dcValidation?.error) {
      setActiveTab("demand");
      return;
    }
    const dcSeason = !dcValidation?.error ? dcValidation?.data : null;

    const buildTariffPart = (season, fallback) => ({
      part: {
        type: "Tou",
        data: {
          purchaseProfile: "",
          sellbackProfile: "",
          options: {},
          schedule: {
            season: season ?? fallback?.part?.data?.schedule?.season ?? [],
          },
        },
      },
    });

    const payload = {
      templateId: -1,
      templateName: templateNameInput?.trim(),
      template: {
        energy: isStaticTimeSeriesUpload?.energy
          ? null
          : buildTariffPart(energySeason, selectedTariffData?.staticTariff?.tariffParameters?.energy),
        export: (isExportEnabled && !isStaticTimeSeriesUpload?.export)
          ? buildTariffPart(exportSeason, selectedTariffData?.staticTariff?.tariffParameters?.export)
          : null,
        demandCharge: buildTariffPart(dcSeason, gridParameters?.componentAttributes?.tariffParameters?.demandCharge),
      },
      templateStatus: "COMPLETE",
    };
    setTemplateSaveLoading(true);
    MGA_API.createUpdateTariffTemplate(payload)
      .then(() => {
        setTemplateNameModalOpen(false);
        templateTariffDirtyRef.current = false;
        displayError("success", t("grid.tariffTemplate.saveSuccess"));
        // Refresh the list to get accurate ids from the server
        MGA_API.getMyTariffTemplates()
          .then((res) => {
            if (Array.isArray(res)) {
              setTariffTemplateNames(res);
              const saved = res.find((t) => t?.templateName === templateNameInput?.trim());
              if (saved) setSelectedTemplateName(String(saved?.id));
            }
          })
          .catch((error) => {
            displayError("error", getErrorMessage(error) || "Failed to save tariff template");
          })
      })
      .catch((error) => {
        displayError("error", getErrorMessage(error) || "Failed to create a tariff template");
      })
      .finally(() => setTemplateSaveLoading(false));
  };

    const handleDeleteTemplate = (id) => {
      if (!id) return;
      const templateItem = tariffTemplateNames?.find((t) => String(t?.id) === String(id));
      setDeleteTemplateId(id);
      setDeleteTemplateName(templateItem?.templateName || "");
      setShowDeleteTemplateModal(true);
    };

    const confirmDeleteTemplate = () => {
      if (!deleteTemplateId) return;
      setDeleteTemplateLoading(true);
      MGA_API.deleteTariffTemplate(deleteTemplateId)
        .then(() => {
          displayError("success", t("grid.tariffTemplate.deleteSuccess") || "Template deleted");
          setShowDeleteTemplateModal(false);
          // refresh list
          return MGA_API.getMyTariffTemplates();
        })
        .then((res) => {
          if (Array.isArray(res)) setTariffTemplateNames(res);
          setTemplatePickerSelected(null);
        })
        .catch((error) => {
          displayError("error", getErrorMessage(error) || "Failed to delete tariff template");
        })
        .finally(() => setDeleteTemplateLoading(false));
    };

  const [isStaticTimeSeriesUpload, setIsStaticTimeSeriesUpload] = useState({
    energy: false,
    export: false,
  });
  const [isGenabilityTimeSeriesUpload, setIsGenabilityTimeSeriesUpload] =
    useState({ energy: false, export: false });
  // External error state for DynamicTariffImport highlighting
  const [importErrors, setImportErrors] = useState({});

  // Compute default start date (one year ago)
  const getDefaultStartDate = () => {
    const today = new Date();
    const oneYearAgo = new Date(today);
    oneYearAgo.setFullYear(today.getFullYear() - 1);
    return oneYearAgo;
  };

  const [importFormData, setImportFormData] = useState({
    startDate: getDefaultStartDate(),
    startTime: "00:00",
    timeResolution: 15,
    range: 1,
    taxRate: 1,
  });
  const [dynamicGraphDataForStatic, setDynamicGraphDataForStatic] = useState({
    energy: null,
    export: null,
  });
  const [dynamicGraphDataForGenability, setDynamicGraphDataForGenability] =
    useState({
      energy: null,
      export: null,
    });

  const [initialTariffType, setInitialTariffType] = useState("");
  const [demandComputation, setDemandComputation] = useState("MONTHLY");
  // For PaginateSelect search in Tariff dropdown
  const [tariffSearchValue, setTariffSearchValue] = useState("");
    const containerRef = useRef(null);
  const accordianRef = useRef(null);
  const [openStepB, setOpenStepB] = useState(false);
  const staticAccordionRef = useRef(null);
  const genAccordionRef = useRef(null);
  const prevLocationRef = useRef({ country: null, zipCode: null });
  const outageRef = useRef(null);

  // Open Step B after key children accordions have mounted to avoid heavy initial render
  useEffect(() => {
    let mounted = true;
    const tryOpen = () => {
      if (!mounted) return;
      if (staticAccordionRef.current || genAccordionRef.current) {
        setTimeout(() => {
          if (mounted) setOpenStepB(true);
        }, 350);
      } else {
        setTimeout(() => {
          if (mounted) setOpenStepB(true);
        }, 600);
      }
    };
    tryOpen();
    return () => {
      mounted = false;
    };
  }, []);

    useHelpFocusBlur(containerRef, setHelperAtom, helperAtom);
    
    const handleContainerClick = (event, cardId) => {
      const interactiveTags = ["INPUT", "SELECT", "TEXTAREA", "BUTTON", "LABEL"];
      if (interactiveTags.includes(event.target.tagName)) return;
      const cardElement = document.querySelector(`[card-id="${cardId}"]`);
      if (cardElement) {
        cardElement.scrollIntoView({ behavior: "smooth", block: "center" });
        cardElement.style.transition = "background-color 0.5s ease";
        cardElement.style.border = "2px solid #42b4e6";
        setTimeout(() => {
          cardElement.style.border = "";
        }, 2000);
      }
    };

  // Filter function for tariffs (like demo)
  const filterTariffs = (options, searchValue) => {
    if (!searchValue) return options;
    const q = searchValue.toLowerCase();
    const qNoSpace = q.replace(/\s+/g, "");
    return options.filter((t) => {
      const code = (t.tariffCode || "").toLowerCase();
      const name = (t.tariffName || "").toLowerCase();
      const lse = (t.lseName || "").toLowerCase();
      const combined = (code + " | " + name + " - " + lse);
      return (
        code.includes(q) || name.includes(q) || lse.includes(q) ||
        combined.includes(q) ||
        code.replace(/\s+/g, "").includes(qNoSpace) ||
        name.replace(/\s+/g, "").includes(qNoSpace) ||
        lse.replace(/\s+/g, "").includes(qNoSpace) ||
        combined.replace(/\s+/g, "").includes(qNoSpace)
      );
    });
  };

  const filteredTariffOptions = filterTariffs(tariffOptions, tariffSearchValue);
  const handleDynamicImportChange = (field, value) => {
    setImportFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
    handleTariffChange();
  };

  const handleDynamicGraphData = (setStateFn, key, newArray) => {
    setStateFn((prev) => ({
      ...prev,
      [key]: newArray,
    }));
  };

  const darkTheme =
    colorScheme === "dark"
      ? "chart-container-tariff-dark full-size-dark"
      : "chart-container-tariff full-size";

  const toggleFullSize = () => {
    setIsFullSize(!isFullSize);
  };
  
  const form = useForm({
    key: JSON.stringify(projectComponents?.grid), // Forces re-render when grid data updates
    initialValues: {
      ...projectComponents?.grid,
      componentAttributes: {
        ...projectComponents?.grid?.componentAttributes,
        gridParameters: {
          ...projectComponents?.grid?.componentAttributes?.gridParameters,
          outageStartDate: projectComponents?.grid?.componentAttributes
            ?.gridParameters?.outageStartDate
            ? new Date(
                projectComponents?.grid?.componentAttributes?.gridParameters?.outageStartDate
              )
            : null,
          outageEndDate: projectComponents?.grid?.componentAttributes
            ?.gridParameters?.outageEndDate
            ? new Date(
                projectComponents?.grid?.componentAttributes?.gridParameters?.outageEndDate
              )
            : null,
          co2Emission: {
            ...projectComponents?.grid?.componentAttributes?.gridParameters
              ?.co2Emission,
            type:
              projectComponents?.grid?.componentAttributes?.gridParameters
                ?.co2Emission?.type || "Fixed",
          },
          powerExport: {
            ...projectComponents?.grid?.componentAttributes?.gridParameters
              ?.powerExport,
            condition:
              projectComponents?.grid?.componentAttributes?.gridParameters
                ?.powerExport?.condition || "No Export",
          },
          powerImport: {
            ...projectComponents?.grid?.componentAttributes?.gridParameters
              ?.powerImport,
            condition:
              projectComponents?.grid?.componentAttributes?.gridParameters
                ?.powerImport?.condition || "Unlimited Import",
            value:
              projectComponents?.grid?.componentAttributes?.gridParameters
                ?.powerImport?.value ?? "0",
          },
        },
      },
      economicAttributes: {
        ...projectComponents?.grid?.economicAttributes,
        gridParameters: {
          ...projectComponents?.grid?.economicAttributes?.gridParameters,
          price:
            projectComponents?.grid?.economicAttributes?.gridParameters
              ?.price || "110",
        },
      },
      uiAttributes: {
        ...projectComponents?.grid?.uiAttributes,
        gridParameters: {
          ...projectComponents?.grid?.uiAttributes?.gridParameters,
          demandManagement: {
            ...projectComponents?.grid?.uiAttributes?.gridParameters
              ?.demandManagement,
            type:
              projectComponents?.grid?.uiAttributes?.gridParameters
                ?.demandManagement?.type || "none",
          },
          outageOccurDuration: {
          ...projectComponents?.grid?.uiAttributes?.gridParameters?.outageOccurDuration,
          backup: projectComponents?.grid?.uiAttributes?.gridParameters?.outageOccurDuration?.backup || "fullBackUp",
          loadValue: projectComponents?.grid?.uiAttributes?.gridParameters?.outageOccurDuration?.loadValue || 100,
        },
        },
      },
    },
    validate: {
      componentAttributes: {
        gridParameters: {
          co2Emission: {
            type: (value) => {
              const co2Enabled = gridParameters?.uiAttributes?.gridParameters?.co2Optimization;
              if (!co2Enabled) return null;
              return value ? null : (
                <>
                  Co<sub>2</sub> Emission Type is required
                </>
              );
            },
            gridEmissionFactor: (value) => {
              const isFixedType =
                gridParameters?.componentAttributes?.gridParameters
                  ?.co2Emission?.type === "Fixed";
              if (!isFixedType) return null;
              const co2Enabled = gridParameters?.uiAttributes?.gridParameters?.co2Optimization;
              if (!co2Enabled) {
                if (!value) return null;
                return mgaRegex?.zeroToThousandWithDecimal.test(value)
                  ? null
                  : t(
                      "grid.validation.co2EmissionFactorRange",
                      formatRange(0, 1000)
                    );
              }
              if (!value) {
                return t("grid.validation.gridEmissionRequired");
              }
              return mgaRegex?.zeroToThousandWithDecimal.test(value)
                ? null
                : t(
                    "grid.validation.co2EmissionFactorRange",
                    formatRange(0, 1000)
                  );
            },
          },
            powerExport: {
              percentage: (value) =>
                projectComponents?.grid?.componentAttributes?.gridParameters
                  ?.powerExport?.condition === "On Purchase Limit" &&
                (isNullOrWhitespace(value)
                  ? t("grid.validation.powerLimitRequired")
                  :  !mgaRegex?.onlyDigitsAndDecimal.test(value)
                ? t("grid.validation.enterPositiveDigits")
                : parseFloat(value) > 1000000000
                ? t("grid.validation.powerLimitExceeded")
                : null),
            },
          powerImport: {
            value: (value) =>
              projectComponents?.grid?.componentAttributes?.gridParameters
                ?.powerImport?.condition === "On Purchase Limit" &&
              (isNullOrWhitespace(value)
                ? t("grid.validation.powerLimitRequired")
                :  !mgaRegex?.onlyDigitsAndDecimal.test(value)
              ? t("grid.validation.enterPositiveDigits")
              : parseFloat(value) > 1000000000
              ? t("grid.validation.powerLimitExceeded")
              : null),
          },
          outageEvent: (value) =>
            projectComponents?.grid?.uiAttributes?.gridParameters
              ?.addOutageManageLoad &&
            (value ? null : t("grid.validation.outageEventRequired")),
          powerOutageCost: (value) => {
            const addOutageManageLoad =
              projectComponents?.grid?.uiAttributes?.gridParameters
                ?.addOutageManageLoad;
            if (!addOutageManageLoad) {
              return null;
            }
            return value === undefined || value === null || value === ""
              ? t("grid.validation.outage.powerOutageCostRequired")
              : !mgaRegex?.zeroToTenPower9WithDecimalRegex?.test(value)
              ? t(
                  "grid.validation.outage.powerOutageCostRange",
                  formatRange(0, 1000000000)
                )
              : null;
          },
        },
      },
      uiAttributes: {
        gridParameters: {
          co2Weight: (value) => {
            const co2Enabled = gridParameters?.uiAttributes?.gridParameters?.co2Optimization;
            if (!co2Enabled) {
              if (value && parseFloat(value) > 1000000000) {
                return t("grid.validation.co2WeightExceeded");
              }
              return null;
            }
            if (!value) {
              return (
                <>
                  Grid Co<sub>2</sub> Weight is required
                </>
              );
            }
            return !mgaRegex?.onlyDigitsAndDecimal.test(value)
              ? t("grid.validation.enterPositiveDigits")
              : parseFloat(value) > 1000000000
              ? t("grid.validation.co2WeightExceeded")
              : null;
          },
          demandReset: (value) => {
            const isFullDemandType =
              gridParameters?.uiAttributes?.gridParameters?.demandManagement
                ?.type === "full";

            if (!isFullDemandType) {
              if (value && parseFloat(value) > 1000000000) {
                return t("grid.validation.demandResetExceeded");
              }
              return null;
            }
            if (!value) return t("grid.validation.demandResetRequired");

            if (!mgaRegex?.oneToHundredWithoutDecimal.test(value)) {
              return t("grid.validation.demandResetRange");
            }

            if (parseFloat(value) > 1000000000) {
              return t("grid.validation.demandResetExceeded");
            }

            return null;
          },
          outageOccurDuration: {
            loadValue: (value) =>
              gridParameters?.uiAttributes?.gridParameters
                ?.addOutageManageLoad &&
              gridParameters?.uiAttributes?.gridParameters?.outageOccurDuration
                ?.backup === "curtailedLoad" &&
              (!value
                ? t("grid.validation.curtailedLoadRequired")
                : !mgaRegex?.oneToHundredRegex?.test(value)
                ? t("grid.validation.curtailedLoadRange")
                : null),
          },
        },
      },
      economicAttributes: {
        gridParameters: {
          price: (value) => {
            const co2Enabled = gridParameters?.uiAttributes?.gridParameters?.co2Optimization;
            if (!co2Enabled) {
              if (value && parseFloat(value) > 1000000000) {
                return t("grid.validation.co2CostImpactExceeded");
              }
              return null;
            }
            if (!value) {
              return (
                <>
                  Co<sub>2</sub> Emission Cost Impact is required
                </>
              );
            }
            return !mgaRegex?.onlyDigitsAndDecimal.test(value)
              ? t("grid.validation.enterPositiveDigits")
              : parseFloat(value) > 1000000000
              ? t("grid.validation.co2CostImpactExceeded")
              : null;
          },
          co2Emission: {
            price: (value) => {
              const co2Enabled = gridParameters?.uiAttributes?.gridParameters?.co2Optimization;
              if (!co2Enabled) return null;
              return value ? null : t("grid.validation.priceRequired");
            },
          },
          omCost: (value) =>
            projectComponents?.grid?.uiAttributes?.gridParameters
              ?.operationCapitalCost &&
            (!value
              ? t("grid.validation.omCostRequired")
              : !mgaRegex?.zeroToTenPower9WithDecimalRegex.test(value)
              ? t("grid.validation.omCost")
              : null),
          newInstallationCost: (value) =>
            projectComponents?.grid?.uiAttributes?.gridParameters
              ?.operationCapitalCost &&
            (value &&
            !mgaRegex?.zeroToTenPower9WithDecimalRegex?.test(value)
              ? t("grid.validation.installationCostRange")
              : null),
        },
      },
    },
  });
  const { setValues } = form;

  const handleInputChange = (category, key, value) => {
    setProjectComponents((prev) => {
      const newState = { ...prev, currentComponent: "grid" };
      set(newState, `grid.${category}.gridParameters.${key}`, value);
      newState.grid.componentAttributes.gridParameters.outageStartDate =
        newState?.grid?.componentAttributes?.gridParameters?.outageStartDate
          ? new Date(
              projectComponents?.grid?.componentAttributes?.gridParameters?.outageStartDate
            )
          : null;
      newState.grid.componentAttributes.gridParameters.outageEndDate = newState
        ?.grid?.componentAttributes?.gridParameters?.outageEndDate
        ? new Date(
            projectComponents?.grid?.componentAttributes?.gridParameters?.outageEndDate
          )
        : null;
      return newState;
    });
    // Update only the specific form field to avoid clearing other errors
    try {
      form.setFieldValue(`${category}.gridParameters.${key}`, value);
    } catch (_) {
      // fallback: do nothing if path invalid; form will still reflect projectComponents
    }
  };

  // Handler to mark form as dirty when tariff data changes
  const handleTariffChange = () => {
    setComponentStatus((prev) => ({
      ...prev,
      grid: { isEditing: true, completed: false },
    }));
    templateTariffDirtyRef.current = true;
  };

  const handleLoadGridSubmit = form.onSubmit(
    (values) => {
      const co2EmissionType =
        values?.componentAttributes?.gridParameters?.co2Emission?.type;
      const co2Profile =
        values?.componentAttributes?.gridParameters?.profileFile;
      if (
        co2EmissionType === "Variable" &&
        (!Array.isArray(co2Profile) || co2Profile.length === 0)
      ) {
        displayError("error", t("grid.co2Emission.profileRequired.message"));
        return;
      }
      handleGridSave();
    },
    (errors) => {
      const firstErrorPath = Object.keys(errors)[0];
      const inputNode = form.getInputNode(firstErrorPath);
      if (inputNode) {
        inputNode.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }
  );

  // Validate outage selections before allowing save (exposed via ref for LoadProject)
  const [baselineStartDate] = useAtom(startDateAtom);

  /**
   * Validates required outage selections and rejects rows whose endpoints cannot be parsed safely.
   * @returns {{error: boolean, message?: string}} Save eligibility and an optional validation message.
   */
  const validateOutageBeforeSave = () => {
    if (form?.values?.uiAttributes?.gridParameters?.addOutageManageLoad) {
      const outageEvent =
        form.values?.componentAttributes?.gridParameters?.outageEvent;
      const outageDates =
        form.values?.componentAttributes?.gridParameters?.outageDates;
      const serializedOutageDates = serializeOutageDates(outageDates);
      if (serializedOutageDates.invalidIndex !== null) {
        const message = t("grid.validation.outage.invalidDateRows");
        displayError("error", message);
        return { error: true, message };
      }
      const start =
        form.values?.componentAttributes?.gridParameters?.outageStartDate;
      const end =
        form.values?.componentAttributes?.gridParameters?.outageEndDate;
      if (!outageEvent) return { error: false }; // no outage event chosen
      if (outageEvent === "noRepetition") {
        if (!start || !end) {
          displayError(
            "error",
            t("grid.validation.outage.selectDates")
          );
          return {
            error: true,
            message: t("grid.validation.outage.selectDates"),
          };
        }
        // Enforce start date not before baselineStartDate if baseline exists
        // if (baselineStartDate) {
        //   const baseline = new Date(baselineStartDate);
        //   const startTs = new Date(start).getTime();
        //   const baselineTs = baseline.getTime();
        //   if (startTs < baselineTs) {
        //     displayError(
        //       "error",
        //       `Outage start must be on or after the load profile start date (${baseline.toLocaleString()}).`
        //     );
        //     return {
        //       error: true,
        //       message: `Outage start must be on or after the load profile start date (${baseline.toLocaleString()}).`,
        //     };
        //   }
        // }
        // Ensure at least one row exists (user clicked Add) if outageDates captured for uniqueness
        if (!Array.isArray(outageDates) || outageDates.length === 0) {
          displayError(
            "error",
            t("grid.validation.outage.pressAdd")
          );
          return {
            error: true,
            message: t("grid.validation.outage.pressAdd"),
          };
        }
      } else if (outageEvent === "eachDay") {
        if (!Array.isArray(outageDates) || outageDates.length === 0) {
          displayError(
            "error",
            t("grid.validation.outage.eachDayAdd")
          );
          return {
            error: true,
            message: t("grid.validation.outage.eachDayAdd"),
          };
        }
      } else if (outageEvent === "eachWeek") {
        if (!Array.isArray(outageDates) || outageDates.length === 0) {
          displayError(
            "error",
            t("grid.validation.outage.eachWeekAdd")
          );
          return {
            error: true,
            message: t("grid.validation.outage.eachWeekAdd"),
          };
        }
      }
    }
    const outageDateRangeError = outageRef.current?.getDateRangeError?.();
    if (outageDateRangeError) {
      displayError("error", t("outage.errors.resolveBeforeSave"));
      return { error: true, message: t("outage.errors.resolveBeforeSave") };
    }
    return { error: false };
  };

  useImperativeHandle(ref, () => ({
    handleLoadGridSubmit,
    validateOutageBeforeSave,
  }));

  const tariffTypeData =
    projectComponents?.grid?.componentAttributes?.tariffParameters?.tariffType;

  const handleInitialTariffDetails = () => {
    const energyDynamicType =
      projectComponents?.grid?.componentAttributes?.tariffParameters?.energy
        ?.part?.type === "Dynamic";

    const exportDynamicType =
      projectComponents?.grid?.componentAttributes?.tariffParameters?.export
        ?.part?.type === "Dynamic";

    const initialData =
      projectComponents?.grid?.componentAttributes?.tariffParameters
        ?.energy?.part?.data?.dynamic?.profileDetail || {}

    const initialImportData = {
      startDate: initialData?.startDate
        ? new Date(initialData?.startDate)
        : getDefaultStartDate(),

      startTime: initialData?.startTime || "00:00",
      timeResolution: initialData?.timeResolution ?? 15,
      range: initialData?.range ?? 1,
      taxRate: initialData?.taxRate ?? 1,
    };
    const initialEnergyGraphData =
      projectComponents?.grid?.componentAttributes?.tariffParameters?.energy
        ?.part?.data?.dynamic;
    const initialExportGraphData =
      projectComponents?.grid?.componentAttributes?.tariffParameters?.export
        ?.part?.data?.dynamic;

    if (tariffTypeData === "genability") {
      handleImportTariffList();
      setGenabilityListItem(
        projectComponents?.grid?.componentAttributes?.tariffParameters
          ?.genabilityTariff?.genabilityListItem
      );
      if (
        projectComponents?.grid?.componentAttributes?.tariffParameters
          ?.genabilityTariff?.genabilityListItem?.length > 0
      ) {
        setIsSingleGenabilityDropdownShown(true);
      }
      setSelectedTariffData((prev) => ({
        ...prev,
        genabilityTariff:
          projectComponents?.grid?.componentAttributes?.tariffParameters,
      }));
      setImportFormData(initialImportData);
      setDynamicGraphDataForGenability({
        energy: initialEnergyGraphData,
        export: initialExportGraphData,
      });
      setIsGenabilityTimeSeriesUpload({
        energy: energyDynamicType,
        export: exportDynamicType,
      });
    } else if (tariffTypeData === "static") {
      setSelectedTariffData((prev) => ({
        ...prev,
        staticTariff: projectComponents?.grid?.componentAttributes,
      }));
      setDynamicGraphDataForStatic({
        energy: initialEnergyGraphData,
        export: initialExportGraphData,
      });
      setImportFormData(initialImportData);
      setIsStaticTimeSeriesUpload({
        energy: energyDynamicType,
        export: exportDynamicType,
      });
    }
  };

  const handleToggle = (updateFn, key) => {
    updateFn((prev) => ({ ...prev, [key]: !prev[key] }));
  };
  const handleSegmentToggle = (updateFn, key, value) => {
    // value: 'generic' => false, 'dynamic' => true
    updateFn((prev) => ({ ...prev, [key]: value === "dynamic" }));
  };

  const handleSegmentToggleWithDataClear = (uploadStateSetter, graphDataSetter, key, value) => {
    // Toggle the upload state
    uploadStateSetter((prev) => ({ ...prev, [key]: value === "dynamic" }));
    // Clear the graph data when toggling
    graphDataSetter((prev) => ({ ...prev, [key]: null }));
    if (value === "dynamic") {
      setSelectedTemplateName(null);
      templateTariffDirtyRef.current = false;
    }
  };

  const handleHelpFieldChange = (field, value) => {
    setHelpForm((prev) => ({ ...prev, [field]: value }));
    setHelpErrors((prev) => ({ ...prev, [field]: "" }));
  };

  const handleHelpFileChange = (file) => {
    setHelpForm((prev) => ({ ...prev, file: file || null }));
  };

  const handleHelpSubmit = () => {
    const nextErrors = {};

    if (!helpForm.ticketType) {
      nextErrors.ticketType = t("grid.getHelp.ticketTypeRequired");
    }

    const trimmedTitle = (helpForm.ticketTitle || "").trim();
    if (!trimmedTitle) {
      nextErrors.ticketTitle = t("grid.getHelp.titleRequired");
    } else if (trimmedTitle.length < 5) {
      nextErrors.ticketTitle = t("grid.getHelp.titleTooShort");
    } else if (trimmedTitle.length > 100) {
      nextErrors.ticketTitle = t("grid.getHelp.titleTooLong");
    }

    const trimmedDesc = (helpForm.ticketDesc || "").trim();
    if (!trimmedDesc) {
      nextErrors.ticketDesc = t("grid.getHelp.descriptionRequired");
    }

    setHelpErrors({
      ticketType: nextErrors.ticketType || "",
      ticketTitle: nextErrors.ticketTitle || "",
      ticketDesc: nextErrors.ticketDesc || "",
    });

    if (Object.keys(nextErrors).length > 0) return;

    const datasetPayload = {
      zipCode: projectDetails?.locationDTO?.zipCode || "",
      countryName: projectDetails?.locationDTO?.country || "",
      projectId: projectId || "",
      designId: designId || "",
      designVersionId: designVersionId || "",
      tariffName:
        electricityTariffSelected === "genability"
          ? genabilityListItem?.[0]?.tariffName || ""
          : "",
      masterTariffId:
        electricityTariffSelected === "genability"
          ? genabilityListItem?.[0]?.masterTariffId || ""
          : "",
      tariffId:
        electricityTariffSelected === "genability"
          ? genabilityListItem?.[0]?.tariffId ||
            ""
          : "",
    };

    const formData = new FormData();
    formData.append("ticketType", helpForm.ticketType);
    formData.append("ticketTitle", trimmedTitle);
    formData.append("ticketDesc", trimmedDesc);
    if(helpForm.file){
      formData.append("file", helpForm.file);
    }
    formData.append("dataSet", JSON.stringify(datasetPayload));
    formData.append("status", "OPEN");


    setHelpSubmitting(true);
    MGA_API.submitTicket(formData)
      .then(() => {
        displayError("success", t("grid.getHelp.success"));
        setHelpForm({ ticketType: "TARIFF_REVIEW", ticketTitle: "", ticketDesc: "", file: null });
        setHelpErrors({ ticketType: "", ticketTitle: "", ticketDesc: "" });
        setShowHelpModal(false);
      })
      .catch((error) => {
        console.error("Help ticket submission failed", error);
        displayError('error', getErrorMessage(error));
      })
      .finally(() => {
        setHelpSubmitting(false);
      });
  };

  const handleTabChange = (value) => {
    if (value === "account" || value === "demand") {
      setShowRawJson(false);
    }
    if (value === "get_help") {
      resetHelpForm();
      setShowHelpModal(true);
      return;
    }
    setActiveTab(value);
  };

  const handleGetHelpClick = (event) => {
    event.preventDefault();
    resetHelpForm();
    setShowHelpModal(true);
  };

  // Track previous tariff selection to avoid infinite loops on state resets
  const prevTariffTypeRef = useRef(electricityTariffSelected);
  useEffect(() => {
    if (prevTariffTypeRef.current === electricityTariffSelected) return; // no actual change
    const defaultImportData = {
      startDate: getDefaultStartDate(),
      startTime: "00:00",
      timeResolution: 15,
      range: 1,
      taxRate: 0,
    };
    if (electricityTariffSelected === 'genability') {
      setImportFormData(defaultImportData);
      setDynamicGraphDataForGenability({ energy: null, export: null });
      setIsGenabilityTimeSeriesUpload({ energy: false, export: false });
      // Clear static related dynamic data
      setDynamicGraphDataForStatic({ energy: null, export: null });
      setIsStaticTimeSeriesUpload({ energy: false, export: false });
    } else if (electricityTariffSelected === 'static') {
      setImportFormData(defaultImportData);
      setDynamicGraphDataForStatic({ energy: null, export: null });
      setIsStaticTimeSeriesUpload({ energy: false, export: false });
      // Clear genability related dynamic data
      setDynamicGraphDataForGenability({ energy: null, export: null });
      setIsGenabilityTimeSeriesUpload({ energy: false, export: false });
    }
    prevTariffTypeRef.current = electricityTariffSelected;
  }, [electricityTariffSelected]);

  useEffect(() => {
    setGridParameters(projectComponents?.grid);
    setElectricityTariffSelected(
      projectComponents?.grid?.componentAttributes?.tariffParameters
        ?.tariffType || "static"
    );
    setInitialTariffType(
      projectComponents?.grid?.componentAttributes?.tariffParameters
        ?.tariffType || "static"
    );
    setCustomerClass(
      projectComponents?.grid?.componentAttributes?.tariffParameters
        ?.genabilityTariff?.customerClass || "GENERAL"
    );
    setDemandComputation(
      projectComponents?.grid?.componentAttributes?.tariffParameters
        ?.demandCharge?.part?.computation || "MONTHLY"
    );
    handleInitialTariffDetails();
  }, [projectComponents]);

  useEffect(() => {
    const country = projectDetails?.locationDTO?.country || null;
    const zipCode = projectDetails?.locationDTO?.zipCode || null;
    const prevCountry = prevLocationRef.current.country;
    const prevZipCode = prevLocationRef.current.zipCode;

    if (prevCountry === null && prevZipCode === null) {
      prevLocationRef.current = { country, zipCode };
      return;
    }

    if (country !== prevCountry || zipCode !== prevZipCode) {
      setElectricityTariffSelected("static");
    }

    prevLocationRef.current = { country, zipCode };
  }, [projectDetails?.locationDTO?.country, projectDetails?.locationDTO?.zipCode]);

  useEffect(() => {
    if (!form.isDirty()) return;
    setComponentStatus((prev) => ({
      ...prev,
      grid: { isEditing: true, completed: false },
    }));
  }, [form.values]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        isFullSize && toggleFullSize();
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [toggleFullSize]);

  /**
   * Validates outage data, builds the Grid payload, and submits it to the API.
   * @returns {void} Stops before submission when outage data or another save requirement is invalid.
   */
  const handleGridSave = () => {
    if (selectedTemplateName && templateTariffDirtyRef.current && !skipTemplateCheckRef.current) {
      setTemplateAlteredModalOpen(true);
      return;
    }
    const outageValidation = validateOutageBeforeSave();
    if (outageValidation.error) return;
    const serializedOutageDates = serializeOutageDates(
      form?.values?.componentAttributes?.gridParameters?.outageDates
    );
    skipTemplateCheckRef.current = false;
    templateTariffDirtyRef.current = false;
    setLoadingComp(true);
    if (electricityTariffSelected === "genability") {
      if (genabilityStale) {
        displayError("error", t("grid.error.customerClassChanged"));
        setLoadingComp(false);
        return;
      }
      try {
        const prevCustomerClass = selectedTariffData?.genabilityTariff?.customerClass;
        if (prevCustomerClass && prevCustomerClass !== customerClass) {
          displayError("error", t("grid.error.customerClassChanged"));
          setLoadingComp(false);
          return;
        }
      } catch (_) {}

      if (!tariffOptions || tariffOptions.length === 0) {
        displayError("error", t("grid.error.importBeforeSaving"));
        setLoadingComp(false);
        return;
      }
      if (!genabilityListItem || genabilityListItem.length === 0) {
        displayError("error", t("grid.error.selectTariffBeforeSaving"));
        setLoadingComp(false);
        return;
      }
    }
    const isEnergyDynamic = isStaticTimeSeriesUpload?.energy || isGenabilityTimeSeriesUpload?.energy;
    const isExportDynamic = isStaticTimeSeriesUpload?.export || isGenabilityTimeSeriesUpload?.export;
    const errs = {};
    if (isEnergyDynamic || isExportDynamic) {
      if (!importFormData?.startDate) errs.startDate = t("grid.error.startDateRequired");
      if (!importFormData?.startTime) errs.startTime = t("grid.error.startTimeRequired");
      if (!importFormData?.timeResolution) errs.timeResolution = t("grid.error.timeResolutionRequired");
      if (!importFormData?.range) errs.range = t("grid.error.rangeRequired");
      // if (importFormData?.taxRate === undefined || importFormData?.taxRate === null || importFormData?.taxRate == "") {
      //   errs.taxRate = "Tax rate is required";
      // } else if (isNaN(Number(importFormData?.taxRate))) {
      //   errs.taxRate = "Tax rate must be a number";
      // } else if (Number(importFormData?.taxRate) < 0) {
      //   errs.taxRate = "Tax rate cannot be negative";
      // }
      if (isEnergyDynamic && !(dynamicGraphDataForStatic?.energy || dynamicGraphDataForGenability?.energy)) {
        errs.file = t("grid.error.tariffFileRequired");
      }
      if (isExportDynamic && !(dynamicGraphDataForStatic?.export || dynamicGraphDataForGenability?.export)) {
        errs.file = t("grid.error.tariffFileRequired");
      }
    }
    setImportErrors(errs);
    if (Object.keys(errs).length > 0) {
      if (isSingleGenabilityDropdownShown) {
        setActiveGenTab(isEnergyDynamic ? "energy_import" : "energy_export");
      } else {
        setActiveTab(isEnergyDynamic ? "energy_import" : "account");
      }
      displayError("error", t("grid.error.clearErrorsBeforeSaving"));
      setLoadingComp(false);
      return;
    }
    const dcTariffValidation = dcTariffRef?.current?.handleValidate();
    const dcGenabilityTariffValidation = dcGenabilityTariffRef?.current?.handleValidate();
    if (electricityTariffSelected !== "genability" && dcTariffValidation?.error) {
      setActiveTab("demand");
      setLoadingComp(false);
      return;
    }
    if(electricityTariffSelected === "genability" && dcGenabilityTariffValidation?.error) {
      setActiveGenTab("demand_charge");
      setLoadingComp(false);
      return;
    }
    const validationResult = tariffRef?.current?.handleValidate();
    if (validationResult?.error) {
      if (isSingleGenabilityDropdownShown) {
        setActiveGenTab("energy_import");
      } else {
        setActiveTab("energy_import");
      }
      setLoadingComp(false);

      return;
    }
    // const validationTou = tariffTouRef?.current?.handleValidate?.();
    // if (validationTou?.error) {
    //   setActiveTab("energy_import");
    //   setLoadingComp(false);

    //   return;
    // }
    let exportValidation = null;
    if (
      gridParameters?.componentAttributes.gridParameters?.powerExport
        ?.condition !== "No Export"
    ) {
      const validationExport = tariffEnergyRef?.current?.handleValidate();
      if (validationExport?.error) {
        if (isSingleGenabilityDropdownShown) {
          setActiveGenTab("energy_export");
        } else {
          setActiveTab("account");
        }
        setLoadingComp(false);

        return;
      } else {
        exportValidation = {
          part: {
            type:
              isStaticTimeSeriesUpload?.export ||
              isGenabilityTimeSeriesUpload?.export
                ? "Dynamic"
                : "Tou",
            data: {
              purchaseProfile: "",
              sellbackProfile: "",
              options: {},
              schedule: {
                season:
                  isStaticTimeSeriesUpload?.export ||
                  isGenabilityTimeSeriesUpload?.export
                    ? null
                    : validationExport?.data,
              },
              dynamic:
                isStaticTimeSeriesUpload?.export ||
                isGenabilityTimeSeriesUpload?.export
                  ? dynamicGraphDataForStatic?.export ||
                    dynamicGraphDataForGenability?.export
                  : null,
            },
          },
        };
      }
    }
    const filteredComponent = selectedDesignAndDesignVersion.componentDTOList.find(
      (comp) => comp.componentType === "Grid"
    );
  
    const demandChargePayload = {
      part: {
        type: electricityTariffSelected === "genability" ? "Dynamic" : "Tou",
        computation: demandComputation,
        data: {
          purchaseProfile:
            electricityTariffSelected === "genability"
              ? "No_Power_profile"
              : "DynamicProfile",
          sellbackProfile:
            electricityTariffSelected === "genability"
              ? "No_Power_profile"
              : "DynamicProfileSame",
          options: {},
          schedule: {
            season:
              electricityTariffSelected === "genability"
                ? dcGenabilityTariffValidation?.data
                : dcTariffValidation?.data || null,
          },
        },
      },
    };

    const handleCheckTruthyKeysInObject = (obj) => {
      return Object.keys(obj)?.filter((key) => obj?.[key])?.length;
    };

    const payload = {
      projectId: projectId,
      designId: designId,
      designVersionId: designVersionId,
      componentType: "Grid",
      componentId: filteredComponent ? filteredComponent.componentId : -1,
      componentAttributes: {
        gridParameters: {
          profileDetail:
            handleCheckTruthyKeysInObject(isStaticTimeSeriesUpload) ||
            handleCheckTruthyKeysInObject(isGenabilityTimeSeriesUpload)
              ? {
                  startDate: new Date(importFormData?.startDate),
                  startTime: importFormData.startTime,
                  timeResolution: importFormData?.timeResolution || "15",
                  range: importFormData?.range,
                  taxRate: importFormData?.taxRate,
                  units: null,
                  tariffUploadType: "IMPORT",
                }
              : null,
          profileFile: gridParameters?.componentAttributes?.gridParameters?.profileFile || [],
          co2Emission: {
            type:
              gridParameters?.componentAttributes.gridParameters.co2Emission
                ?.type || "Fixed",
            gridEmissionFactor:
            gridParameters?.componentAttributes?.gridParameters
                  ?.co2Emission?.type === "Fixed"?
              gridParameters?.componentAttributes.gridParameters.co2Emission
                ?.gridEmissionFactor : "0",
          },
          outageEvent: form?.values?.uiAttributes?.gridParameters
            ?.addOutageManageLoad
            ? gridParameters?.componentAttributes.gridParameters.outageEvent
            : null,
          outageStartDate:
            form?.values?.componentAttributes?.gridParameters?.outageStartDate,
          outageEndDate:
            form?.values?.componentAttributes.gridParameters.outageEndDate,
          powerOutageCost:
            form?.values?.componentAttributes?.gridParameters?.powerOutageCost || "0",
          powerImport:
            (() => {
              const condition =
                gridParameters?.componentAttributes?.gridParameters?.powerImport?.condition ||
                "Unlimited Import";
              const rawValue =
                gridParameters?.componentAttributes?.gridParameters?.powerImport?.value ??
                "0";
              const value =
                condition === "On Purchase Limit"
                  ? rawValue === "" || rawValue === null || rawValue === undefined
                    ? "0"
                    : rawValue
                  : "0";
              return { condition, value };
            })(),
          powerExport: {
            condition:
              gridParameters?.componentAttributes.gridParameters?.powerExport
                .condition || "No Export",
            percentage:
              gridParameters?.componentAttributes.gridParameters?.powerExport
                ?.percentage || "0",
          },
          outageDates: form?.values?.uiAttributes?.gridParameters
            ?.addOutageManageLoad
            ? serializedOutageDates.dates
            : [],
        },
        tariffParameters: {
          tariffType: electricityTariffSelected,
          genabilityTariff:
            electricityTariffSelected === "genability"
              ? {
                  customerClass,
                  genabilityListItem,
                }
              : null,
          energy: {
            part: {
              type:
                isStaticTimeSeriesUpload?.energy ||
                isGenabilityTimeSeriesUpload?.energy
                  ? "Dynamic"
                  : "Tou",
              data: {
                purchaseProfile: "",
                sellbackProfile: "",
                options: {},
                schedule: {
                  season:
                    isStaticTimeSeriesUpload?.energy ||
                    isGenabilityTimeSeriesUpload?.energy
                      ? null
                      : validationResult?.data,
                },
                dynamic:
                  isStaticTimeSeriesUpload?.energy ||
                  isGenabilityTimeSeriesUpload?.energy
                    ? dynamicGraphDataForStatic?.energy ||
                      dynamicGraphDataForGenability?.energy
                    : null,
              },
            },
          },
          export: exportValidation,
          demandCharge: demandChargePayload,
        },

        loadAttributes: null,
      },
      economicAttributes: {
        gridParameters: {
          price:
            gridParameters?.economicAttributes?.gridParameters?.price || "0",
          co2Emission: {},
          newInstallationCost:
            gridParameters?.economicAttributes?.gridParameters
              ?.newInstallationCost || "0",
          omCost:
            gridParameters?.economicAttributes?.gridParameters?.omCost || "0",
        },
        loadAttributes: null,
      },
      uiAttributes: {
        gridParameters: {
          co2Weight:
            gridParameters?.uiAttributes?.gridParameters?.co2Weight || "0",
          co2Optimization:
            projectComponents?.grid?.uiAttributes?.gridParameters
              ?.co2Optimization || false,
          co2Emission: {
            co2Weight: gridParameters.co2Emission?.co2Weight || "0",
          },
          demandReset:
            gridParameters?.uiAttributes?.gridParameters?.demandReset || "0",
          demandManagement: {
            type:
              gridParameters?.uiAttributes?.gridParameters?.demandManagement
                ?.type || "Limited",
            value:
              gridParameters?.uiAttributes?.gridParameters?.demandManagement
                ?.value || "0",
          },
          timeOfUseOptimization:
            gridParameters?.uiAttributes?.gridParameters
              .timeOfUseOptimization || false,
          optimizeDemandResponse:
            gridParameters?.uiAttributes?.gridParameters
              ?.optimizeDemandResponse || false,
          outageOccurDuration: gridParameters?.uiAttributes?.gridParameters
            ?.addOutageManageLoad
            ? {
                backup:
                  gridParameters?.uiAttributes?.gridParameters
                    ?.outageOccurDuration?.backup || "curtailedLoad",
                loadValue:
                  gridParameters?.uiAttributes?.gridParameters
                    ?.outageOccurDuration?.loadValue || "0",
              }
            : null,
          operationCapitalCost:
            projectComponents?.grid?.uiAttributes?.gridParameters
              ?.operationCapitalCost || false,
          addOutageManageLoad:
            projectComponents?.grid?.uiAttributes?.gridParameters
              ?.addOutageManageLoad || false,
        },
        loadAttributes: null,
      },
      datasource:
        handleCheckTruthyKeysInObject(isStaticTimeSeriesUpload) ||
        handleCheckTruthyKeysInObject(isGenabilityTimeSeriesUpload)
          ? "Upload"
          : "OTHER",
    };
    (async () => {
      try {
        const res = await MGA_API.saveLoadComponent(payload);
        setComponentStatus((prev) => ({
          ...prev,
          grid: { completed: true, isEditing: false },
        }));
        try {
          const projRes = await MGA_API.editProject(
            projectId
          );
          setProjectDetails((prev) => ({
            ...prev,
            userId: projRes.userId || "",
            currencyCode: projRes?.projectDTO?.currencyCode || "$",
            projectDTO: projRes.projectDTO || {},
            componentDTOList:
              flattenCountComponentDTOList(projRes.countComponentDTOList) || [],
            designWithVersionsDTOList: projRes.designWithVersionsDTOList || [],
            locationDTO: projRes.locationDTO || {},
            countComponentDTOList: projRes.countComponentDTOList,
            designComponentsList: flattenDesignCountComponent(projRes?.designComponentsList) || [],
          }));
        } catch (refreshErr) {
          console.error('Project refresh failed:', refreshErr);
          displayError('error', getErrorMessage(refreshErr));
        }
        displayError("success", t("grid.save.success"));
        setSelectedTemplateName(null);
        templateTariffDirtyRef.current = false;
      } catch (error) {
        displayError('error', getErrorMessage(error));
        console.error('Grid save failed:', error);
        // // Derive human-readable message
        // let message = 'Failed to save Grid details';
        // if (error?.response?.data) {
        //   if (typeof error.response.data === 'string') message = error.response.data;
        //   else if (error.response.data?.message) message = error.response.data.message;
        //   else if (error.response.data?.error) message = error.response.data.error;
        // } else if (error?.message) {
        //   message = error.message;
        // }
        // displayError('error', message);
      } finally {
        setLoadingComp(false);
      }
    })();
  };

  const [helpMenuData] = useAtom(helpContextMenuAtom);
    
  const getFieldAttributes = (fieldKey) => {
    const field = helpMenuData?.grid?.[fieldKey];
    return {
      title: field?.title || "",
      "data-description": field?.description || "",
      // placeholder: field?.placeholder || "",
    };
  };
  
  useEffect(() => {
    const containerElement = containerRef.current;
    if (!containerElement) return;

    containerElement.addEventListener("focusin", handleFocus);
    containerElement.addEventListener("focusout", handleBlur);

    return () => {
      containerElement.removeEventListener("focusin", handleFocus);
      containerElement.removeEventListener("focusout", handleBlur);
    };
  }, []);

  const handleBlur = (event) => {
    const nextFocusedElement = event.relatedTarget;
    if (
      containerRef.current &&
      !containerRef.current.contains(nextFocusedElement)
    ) {
      setHelperAtom({
        ...helperAtom,
        isFocused: false,
        helpSection: {
          title: "",
          description: "",
          type: "",
          other: "",
        },
      });
    }
  };
  const handleFocus = (event) => {
    const dataFieldElement =
      event.target?.closest?.("[data-id]") || event.target;
    const dataId = dataFieldElement?.getAttribute?.("data-id");
    if (dataId) {
      const cardElement = document.querySelector(`[card-id="${dataId}"]`);
      if (cardElement) {
        cardElement.scrollIntoView({ behavior: "smooth", block: "center" });
        cardElement.style.transition = "background-color 0.5s ease";
        cardElement.style.border = "2px solid #42b4e6";
        setTimeout(() => {
          cardElement.style.border = "";
        }, 2000);
      }
    }
  };

  const header = () => (
    <>
      {" "}
      <span className="stepText col-md-1 px-0">
        {`Step ${addedStepsSeries.indexOf("grid") + 1}`}: C. &nbsp;
      </span>
      <span
        className="ml-2 mt-0 col-md-8 px-0"
        style={{
          fontSize: "16px",
          fontWeight: 400,
          color:
            localStorage.getItem("mantine-color-scheme") === "dark"
              ? "#d5d7e0"
              : "#475f7b",
        }}
      >
        {t("grid.header.investmentDetails")}
      </span>
    </>
  );

  const header2 = () => (
    <>
      {" "}
      <span className="stepText col-md-1 px-0">
        {`Step ${addedStepsSeries.indexOf("grid") + 1}`}:{" "} E
        {/* {gridParameters?.uiAttributes?.gridParameters?.operationCapitalCost
          ? "E"
          : "E"} */}
        .
      </span>
      <span
        className="ml-2 mt-0 col-md-8 px-0"
        style={{
          fontSize: "16px",
          fontWeight: 400,
          color: colorScheme === "dark" ? "#d5d7e0" : "#475f7b",
        }}
      >
        &nbsp;{t("grid.header.tariffSetupOption")}
      </span>
    </>
  );
  const children = () => (
    <div
      data-id="accordion-grid-2"
      onClick={(e) => handleContainerClick(e, "accordion-grid-2")}
      onKeyDown={(e) => handleContainerKeyDown(e, "accordion-grid-2")}
      tabIndex={0}
      role="button"
      ref={accordianRef}
    >
      <Grid>
        <Grid.Col style={{ alignContent: "flex-end" }} {...responsiveCol}>
          <Switch
            labelPosition="left"
            label={t("grid.switch.investmentEnable")}
            checked={
              gridParameters?.uiAttributes?.gridParameters
                ?.operationCapitalCost || false
            }
            color="seGreen.0"
            {...form.getInputProps(
              "uiAttributes.gridParameters.operationCapitalCost"
            )}
            onChange={(event) => {
              handleInputChange(
                "uiAttributes",
                "operationCapitalCost",
                event.currentTarget.checked
              );
            }}
          />
        </Grid.Col>
        {/* Outage & Load Management moved to its own step */}
      </Grid>
      <br />
      {gridParameters?.uiAttributes?.gridParameters?.operationCapitalCost && (
        <OpexCapex
          form={form}
          handleInputChange={handleInputChange}
          gridParameters={gridParameters}
          getFieldAttributes={getFieldAttributes}
        />
      )}
    </div>
  );

  const headerDefineOutage = () => (
    <>
      <span className="stepText col-md-1 px-0">
        {`Step ${addedStepsSeries?.indexOf("grid") + 1}`}: {"C"}.
      </span>
      <span
        className="ml-2 mt-0 col-md-8 px-0"
        style={{
          fontSize: "16px",
          fontWeight: 400,
          color: colorScheme === "dark" ? "#d5d7e0" : "#475f7b",
        }}
      >
        &nbsp; {t("grid.header.outageAndLoadManagement")}
      </span>
    </>
  );

  const childrenDefineOutage = () => (
    <div
      data-id="accordion-grid-outage"
      onClick={(e) => handleContainerClick(e, "accordion-grid-outage")}
      onKeyDown={(e) => handleContainerKeyDown(e, "accordion-grid-outage")}
      tabIndex={0}
      role="button"
      ref={accordianRef}
    >
      <Grid>
        <Grid.Col style={{ alignContent: "flex-end" }} {...responsiveCol}>
          <Switch
            color="seGreen.0"
            labelPosition="left"
            label={t("grid.switch.enableOutageAndLoadManagement")}
            checked={
              gridParameters?.uiAttributes?.gridParameters
                ?.addOutageManageLoad || false
            }
            {...form.getInputProps(
              "uiAttributes.gridParameters.addOutageManageLoad"
            )}
            onChange={(event) => {
              handleInputChange(
                "uiAttributes",
                "addOutageManageLoad",
                event.currentTarget.checked
              );
            }}
          />
        </Grid.Col>
      </Grid>
      <br />
      {gridParameters?.uiAttributes?.gridParameters?.addOutageManageLoad && (
        <OutageLoadManagement
          ref={outageRef}
          form={form}
          handleInputChange={handleInputChange}
          gridParameters={gridParameters}
          getFieldAttributes={getFieldAttributes}
        />
      )}
    </div>
  );

  const header1_1 = () => (
    <>
      <span className="stepText col-md-1 px-0">
        {`Step ${addedStepsSeries?.indexOf("grid") + 1}`}:{" "}
        {"D"}
        .
      </span>
      <span
        className="ml-2 mt-0 col-md-8 px-0"
        style={{
          fontSize: "16px",
          fontWeight: 400,
          color: colorScheme === "dark" ? "#d5d7e0" : "#475f7b",
        }}
      >
        &nbsp; {t("grid.header.tariffConfig")}
      </span>
    </>
  );

  const children1_1 = () => (
    <>
      <AlertIcon
        alert={alert}
        onClose={() => setAlert({ ...alert, alertPopUpStatus: false })}
      />

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "32px",
          marginBottom: "24px",
          marginTop: "24px",
          flexWrap: "wrap",
        }}
        data-id="accordion-grid-3"
        onClick={(e) => handleContainerClick(e, "accordion-grid-3")}
        onKeyDown={(e) => handleContainerKeyDown(e, "accordion-grid-3")}
        tabIndex={0}
        role="button"
        ref={accordianRef}
      >
        <Card
          shadow="sm"
          padding="md"
          radius="md"
          onClick={() => {
            if (electricityTariffSelected === "static") return;
            setElectricityTariffSelected("static");
            handleTariffChange();
          }}
          style={{
            width: "600px !important",
            maxWidth: "600px",
            flex: "0 0 600px",
            minHeight: "140px",
            flexShrink: 0,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            border:
              electricityTariffSelected === "static"
                ? "2px solid #3dcd58"
                : "2px solid #e0e0e0",
            boxShadow:
              electricityTariffSelected === "static"
                ? "0 0 0 2px #3dcd5833"
                : undefined,
            transition: "border 0.2s, box-shadow 0.2s",
          }}
        >
          <Text align="center" weight={700} size="md" style={{ marginBottom: "6px" }}>
            {t("grid.card.genericTariffTitle")}
          </Text>
          <Text align="center" className="loadText mb-1" style={{  lineHeight: "1.3" }}>
            {t("grid.card.genericTariffDesc")}
          </Text>
        </Card>
        {_.includes(
          GENABILITY_COUNTRIES,
          projectDetails?.locationDTO?.country
        ) && (
          <Card
            shadow="sm"
            padding="md"
            radius="md"
            onClick={() => {
              if (electricityTariffSelected === "genability") return;
              setElectricityTariffSelected("genability");
              handleTariffChange();
            }}
            style={{
            width: "600px !important",
            maxWidth: "600px",
            flex: "0 0 600px",
              minHeight: "100px",
              flexShrink: 0,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              border:
                electricityTariffSelected === "genability"
                  ? "2px solid #3dcd58"
                  : "2px solid #e0e0e0",
              boxShadow:
                electricityTariffSelected === "genability"
                  ? "0 0 0 2px #3dcd5833"
                  : undefined,
              transition: "border 0.2s, box-shadow 0.2s",
            }}
          >
            <Text align="center" weight={700} size="md" style={{ marginBottom: "6px" }}>
              {t("grid.card.genabilityTariffTitle")}
            </Text>
            <Text align="center" className="loadText mb-1" style={{  lineHeight: "1.3" }}>
              {t("grid.card.genabilityTariffDesc")}
            </Text>
          </Card>
        )}
      </div>
    </>
  );


  // Map demandType to card index for UI selection
  const demandTypeToIndex = {
    FIXEDORONMAXPOWER: 0,
    SUBSCRIBEDDEMAND: 1,
    RATCHET: 2,
    TOUANDTIER: 3,
  };

  // Set selectedDemandCard based on demandType in initialValues (API response)
  useEffect(() => {
    const demandType =
      projectComponents?.grid?.componentAttributes?.demandCharge?.demandType ||
      "FIXEDORONMAXPOWER";
    setSelectedDemandCard(demandTypeToIndex[demandType] ?? 0);
  }, [projectComponents?.grid?.componentAttributes?.demandCharge?.demandType]);
  const [rawLoading, setRawLoading] = useState(false);
  const [showRawJson, setShowRawJson] = useState(false);

    const handleFetchRawTariff = async () => {
    // Always show raw panel and fetch latest raw tariff on each click
    setShowRawJson(true);

    const selected = genabilityListItem?.[0];
    if (!selected) return;

    setRawLoading(true);
    try {
      const raw = await MGA_API.getTariffRawData(
        selected.masterTariffId,
        selected.tariffId,
        selected.lseId
      );
      setSelectedTariffRaw(raw);
    } catch (e) {
      console.error('Failed to fetch raw tariff:', e);
      displayError('error', getErrorMessage(e));
    } finally {
      setRawLoading(false);
    }
  };
  // New method to update demandType inside componentAttributes.demandCharge

  const selectedColorTheme = colorScheme === "dark" ? "#434B4D" : "#e0e0e0";

  const handleImportTariffList = () => {
    setTariffLoading(true);
    setImportAttempted(true);
    setGenabilityListItem(null);
    setGenabilityStale(false);
    MGA_API.getGenabilityTariffList(
      customerClass,
      projectDetails?.locationDTO?.zipCode
    )
      .then((res) => {
        if (res?.results?.length > 0) {
          setTariffOptions(res.results);
          setGenabilityStale(false);
        } else {
          setTariffOptions([]);
        }
        setTariffLoading(false);
      })
      .catch((error) => {
        setTariffOptions([]);
        setTariffLoading(false);
        displayError('error', getErrorMessage(error));
      });
  };

  const handleContainerKeyDown = (event, accordionId) => {
    if (event.target !== event.currentTarget) return;
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      handleContainerClick(event, accordionId);
    }
  };

  const children2 = () => (
    <div
      data-id="accordion-grid-4"
      onClick={(e) => handleContainerClick(e, "accordion-grid-4")}
      onKeyDown={(e) => handleContainerKeyDown(e, "accordion-grid-4")}
      tabIndex={0}
      role="button"
      ref={accordianRef}
    >
      {
        <Tabs
          color="teal"
          value={activeTab}
          onTabChange={handleTabChange}
          defaultValue="energy_import"
        >
          <Tabs.List style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', position: 'relative' }}>
            <Tabs.Tab value="energy_import" data-id="field-25" {...getFieldAttributes('field-25')}>{t("grid.tab.importTariff")}</Tabs.Tab>
            {form?.values?.componentAttributes?.gridParameters?.powerExport
              ?.condition !== "No Export" && (
              <Tabs.Tab value="account" data-id="field-26" {...getFieldAttributes('field-26')}>{t("grid.tab.exportTariff")}</Tabs.Tab>
            )}
            <Tabs.Tab value="demand" data-id="field-27" {...getFieldAttributes('field-27')}>{t("grid.tab.demandCharges")}</Tabs.Tab>
            <Tabs.Tab value="other" disabled data-id="field-28" {...getFieldAttributes('field-28')}>
              {t("grid.tab.additionalCharges")}
            </Tabs.Tab>

            <Tabs.Tab value="bill_summary" disabled data-id="field-29" {...getFieldAttributes('field-29')}>
              {t("grid.tab.billSummary")}
            </Tabs.Tab>

            {!(activeTab === 'energy_import' && isStaticTimeSeriesUpload?.energy) &&
        !(activeTab === 'account' && isStaticTimeSeriesUpload?.export) &&
        userScope?.access?.myTariffTemplates &&
        tariffTemplateNames?.length > 0 && (
          <>
            <a
              href="#"
              onClick={handleOpenTemplatePicker}
              style={{ textDecoration: 'none', position: 'absolute', right: 'calc(5% + 15px)' }}
            >
              {t("grid.tariffTemplate.selectLink")}
            </a>
            <span style={{ position: 'absolute', right: '5%', color: '#ccc', userSelect: 'none' }}>|</span>
          </>
         )}
            
            <a
              href="#"
              onClick={handleGetHelpClick}
              style={{ position: 'absolute', right: '12px', textDecoration: 'none', display: 'flex', alignItems: 'center' }}
            >
              {t("grid.link.getHelp")}
            </a>
          </Tabs.List>
          <Tabs.Panel value="energy_import" pt="xs">
            <Grid gutter="md" className="mt-2 mb-2">
              <Grid.Col span={12}>
                <Group position="center" align="center">
                  {/* <Text>Generic Configuration</Text> */}
                  <SegmentedControl
                    value={isStaticTimeSeriesUpload?.energy ? 'dynamic' : 'generic'}
                    onChange={(val) => handleSegmentToggleWithDataClear(setIsStaticTimeSeriesUpload, setDynamicGraphDataForStatic, 'energy', val)}
                    data={[
                      { label: t("grid.segmented.genericConfig"), value: 'generic' },
                      { label: t("grid.segmented.dynamicConfig"), value: 'dynamic' },
                    ]}
                    color="seGreen.0"
                  />
                  {/* <Text>Dynamic Configuration</Text> */}
                </Group>
              </Grid.Col>
            </Grid>
            {isStaticTimeSeriesUpload?.energy ? (
              <DynamicTariffImport
                importFormData={importFormData}
                handleDynamicImportChange={handleDynamicImportChange}
                dynamicGraphData={dynamicGraphDataForStatic?.energy}
                setDynamicGraphData={(data) =>
                  handleDynamicGraphData(
                    setDynamicGraphDataForStatic,
                    "energy",
                    data
                  )
                }
                externalErrors={importErrors}
                getFieldAttributes={getFieldAttributes}
                onChange={handleTariffChange}
              />
            ) : (
              <div
                className={isFullSize ? darkTheme : "chart-container-tariff"}
              >
                {/* <FontAwesomeIcon
                  icon={isFullSize ? faCompress : faExpand}
                  className={
                    isFullSize
                      ? "zoomed-full-size-icon-tariff"
                      : "full-size-icon-tariff"
                  }
                  onClick={toggleFullSize}
                /> */}
                <Tariff
                  ref={tariffRef}
                  tariffTemplate={
                    selectedTariffData?.staticTariff?.tariffParameters?.energy
                      ?.part?.data?.schedule?.season || null
                  }
                  isVersionCompleted={selectedVersion?.versionStatus === "COMPLETED" || selectedVersion?.versionStatus === "SIMULATED"}
                  getFieldAttributes={getFieldAttributes}
                  onChange={handleTariffChange}
                />
              </div>
            )}
          </Tabs.Panel>
          <Tabs.Panel value="demand" pt="xs">
            <div
              className={
                isFullSize ? darkTheme : "chart-container-tariff"
              }
            >
              {/* <FontAwesomeIcon
                icon={isFullSize ? faCompress : faExpand}
                className={
                  isFullSize
                    ? "zoomed-full-size-icon-tariff"
                    : "full-size-icon-tariff"
                }
                onClick={toggleFullSize}
              /> */}
              <Group position="center" align="center" className="mt-2 pb-4">
                  <Text>{t("grid.demandComputation.daily")}</Text>
                  <Switch
                    checked={demandComputation === "MONTHLY"}
                    onChange={(event) => {
                      setDemandComputation(event.currentTarget.checked ? "MONTHLY" : "DAILY");
                      handleTariffChange();
                    }}
                    color="seGreen.0"
                    size="md"
                    styles={(theme) => ({
                      track: { backgroundColor: "#3dcd58" }
                    })}
                  />
                <Text>{t("grid.demandComputation.monthly")}</Text>
              </Group> 
              <DemandCharge
                ref={dcTariffRef}
                tariffTemplate={
                  gridParameters?.componentAttributes?.tariffParameters
                    ?.demandCharge?.part?.data?.schedule?.season || null
                }
                importTariffSeasons={
                  selectedTariffData?.staticTariff?.tariffParameters?.energy
                    ?.part?.data?.schedule?.season || null
                }
                getImportTariffSeasons={() =>
                  tariffRef?.current?.getJsonData?.() ||
                  selectedTariffData?.staticTariff?.tariffParameters?.energy
                    ?.part?.data?.schedule?.season ||
                  null
                }
                isVersionCompleted={selectedVersion?.versionStatus === "COMPLETED" || selectedVersion?.versionStatus === "SIMULATED"}
                getFieldAttributes={getFieldAttributes}
                onChange={handleTariffChange}
              />
            </div>
          </Tabs.Panel>
          <Tabs.Panel value="account" pt="xs">
            <Grid gutter="md" className="mt-2 mb-2">
              <Grid.Col span={12}>
                <Group position="center" align="center">
                  {/* <Text>Generic Configuration</Text> */}
                  <SegmentedControl
                    value={isStaticTimeSeriesUpload?.export ? 'dynamic' : 'generic'}
                    onChange={(val) => handleSegmentToggleWithDataClear(setIsStaticTimeSeriesUpload, setDynamicGraphDataForStatic, 'export', val)}
                    data={[
                      { label: t("grid.segmented.genericConfig"), value: 'generic' },
                      { label: t("grid.segmented.dynamicConfig"), value: 'dynamic' },
                    ]}
                    color="seGreen.0"
                  />
                  {/* <Text>Dynamic Configuration</Text> */}
                </Group>
              </Grid.Col>
            </Grid>
            {isStaticTimeSeriesUpload?.export ? (
              <DynamicTariffImport
                importFormData={importFormData}
                handleDynamicImportChange={handleDynamicImportChange}
                dynamicGraphData={dynamicGraphDataForStatic?.export}
                setDynamicGraphData={(data) =>
                  handleDynamicGraphData(
                    setDynamicGraphDataForStatic,
                    "export",
                    data
                  )
                }
                externalErrors={importErrors}
                getFieldAttributes={getFieldAttributes}
                onChange={handleTariffChange}
              />
            ) : (
              <div
                className={
                  isFullSize
                    ? "chart-container-tariff full-size"
                    : "chart-container-tariff"
                }
              >
                {/* <FontAwesomeIcon
                  icon={isFullSize ? faCompress : faExpand}
                  className={
                    isFullSize
                      ? "zoomed-full-size-icon-tariff"
                      : "full-size-icon-tariff"
                  }
                  onClick={toggleFullSize}
                /> */}
                <div>
                  <Tariff
                    ref={tariffEnergyRef}
                    tariffTemplate={
                      selectedTariffData?.staticTariff?.tariffParameters?.export
                        ?.part?.data?.schedule?.season || null
                    }
                  isExport
                  isVersionCompleted={selectedVersion?.versionStatus === "COMPLETED" || selectedVersion?.versionStatus === "SIMULATED"}
                  getFieldAttributes={getFieldAttributes}
                  onChange={handleTariffChange}
                  />
                </div>
              </div>
            )}
          </Tabs.Panel>
        </Tabs>
      }
      {!(activeTab === 'energy_import' && isStaticTimeSeriesUpload?.energy) &&
        !(activeTab === 'account' && isStaticTimeSeriesUpload?.export) &&
        userScope?.access?.myTariffTemplates && (
        <span className="d-flex justify-content-end mt-1">
          <se-button aria-label="grid-save-as-template" color="secondary" onClick={handleSaveAsTemplate}>{t("grid.tariffTemplate.saveButton")}</se-button>
        </span>
      )}
    </div>
  );

  const header3 = () => (
    <>
      <span className="stepText col-md-1 px-0">
        {`Step ${addedStepsSeries.indexOf("grid") + 1}`}: D.&nbsp;
      </span>
      <span
        className="ml-2 mt-0 col-md-8 px-0"
        style={{
          fontSize: "16px",
          fontWeight: 400,
          color:
            localStorage.getItem("mantine-color-scheme") === "dark"
              ? "#d5d7e0"
              : "#475f7b",
        }}
      >
        {t("grid.header.genabilityData")}
      </span>
    </>
  );
  const children3 = () => (
    <div
      data-id="accordion-grid-5"
      onClick={(e) => handleContainerClick(e, "accordion-grid-5")}
      onKeyDown={(e) => handleContainerKeyDown(e, "accordion-grid-5")}
      tabIndex={0}
      role="button"
      ref={accordianRef}
    >
      <Grid gutter="md" className="mt-2 mb-2">
        <Grid.Col {...responsiveCol}>
          <Select
            rightSection={<se-icon size="nano">arrow3_down</se-icon>}
            rightSectionProps={{ style: { pointerEvents: "none" } }}
            label={t("grid.label.customerClass")}
            placeholder={t("grid.label.customerClass")}
            value={customerClass}
            data={[
              { value: "GENERAL", label: "GENERAL" },
              { value: "RESIDENTIAL", label: "RESIDENTIAL" },
              { value: "SPECIAL_USE", label: "SPECIAL USE" },
              // { value: "PROPOSED", label: "PROPOSED" },
            ]}
            required
            onChange={(value) => {
              setCustomerClass(value);
              setIsSingleGenabilityDropdownShown(false);
              setGenabilityListItem(null);
              setTariffOptions([]);
              setImportAttempted(false);
              setGenabilityStale(true);
              handleTariffChange();
            }}
            withinPortal
            searchable
          />
        </Grid.Col>
        <Grid.Col {...responsiveCol}>
          <TextInput
            value={projectDetails?.locationDTO?.country || ""}
            placeholder={t("grid.placeholder.country")}
            label={t("grid.label.country")}
            required
            disabled
            style={{ flex: 1 }}
          />
        </Grid.Col>
        <Grid.Col
          {...responsiveCol}
          style={{ display: "flex", alignItems: "flex-end", gap: 8 }}
        >
          <TextInput
            value={projectDetails?.locationDTO?.zipCode || ""}
            placeholder={t("grid.placeholder.zipCode")}
            label={t("grid.label.zipCode")}
            required
            disabled
            style={{ flex: 1 }}
          />
          <Button
            variant="outline"
            style={{ height: 36 }}
            onClick={handleImportTariffList}
          >
            {t("grid.button.import")}
          </Button>
        </Grid.Col>
        <Grid.Col span={1} offset={2}>
          <a
            href="#"
            onClick={handleGetHelpClick}
            className="link-offset-3 ms-auto px-3 py-2 d-inline-flex"
          >
            {t("grid.link.getHelp")}
          </a>
        </Grid.Col>

        {/* Error modal for country restriction */}
        <LoadingOverlay visible={tariffLoading} overlayBlur={2} />
      </Grid>
      {tariffOptions?.length > 0 ? (
        <Grid>
          <Grid.Col span={9}>
            <PaginateSelect
              label={t("grid.label.tariff")}
              selectProps={{
                label: t("grid.label.selectTariff"),
              }}
              placeholder={t("grid.placeholder.selectTariff")}
              data={filteredTariffOptions.map((tariff) => ({
                value: tariff.masterTariffId,
                label: tariff?.tariffCode +' | '+ tariff?.tariffName + " - " + tariff?.lseName,
              }))}
              value={genabilityListItem?.[0]?.masterTariffId}
              onChange={(value) => {
                setShowRawJson(false);
                if (value) {
                  // Only select if value exists in filteredTariffOptions
                  const selectedTariffItem = filteredTariffOptions.find(
                    (tariff) => tariff.masterTariffId === value,
                  );
                  if (selectedTariffItem) {
                    setTariffLoading(true);
                    setGenabilityListItem([selectedTariffItem]);
                    handleTariffChange();
                    MGA_API.getSingleGenabilityTariff(
                      value,
                      selectedTariffItem?.tariffId,
                      selectedTariffItem?.lseId,
                    )
                      .then((res) => {
                        setIsSingleGenabilityDropdownShown(true);
                        setTariffLoading(false);
                        setSelectedTariffData((prev) => ({
                          ...prev,
                          genabilityTariff: res,
                        }));
                        setGenabilityStale(false);
                      })
                      .catch((error) => {
                        displayError('error', getErrorMessage(error));
                        setTariffLoading(false);
                      });
                  } else {
                    // If not found, treat as search
                    setTariffSearchValue(value);
                  }
                } else {
                  // User cleared input or typed after selection: clear selection and input
                  setGenabilityListItem([]);
                  setTariffSearchValue("");
                  setIsSingleGenabilityDropdownShown(false);
                  setSelectedTariffData((prev) => ({
                    ...prev,
                    genabilityTariff: null,
                  }));
                  handleTariffChange();
                }
              }}
              loading={tariffLoading}
              disabled={tariffLoading}
              searchable
              searchValue={tariffSearchValue}
              onSearchChange={setTariffSearchValue}
              nothingFound={t("grid.select.noTariffs")}
              expandOnSelect
              // style={{ minWidth: 300 }}
              style={{ width: "100%" }}
              theme={colorScheme === "dark" ? "dark" : "light"}
            />
          </Grid.Col>
        </Grid>
      ) : (importAttempted && !tariffLoading ? <span className="text-danger">{t("grid.select.noTariffOptions")}</span> : null)}
      {isSingleGenabilityDropdownShown && show_gen()}
    </div>
  );

  const [activeGenTab, setActiveGenTab] = useState("energy_import");

  const show_gen = () => {
    return (
      <Tabs
        color="teal"
        value={activeGenTab}
        onTabChange={(value) => {
          if (value === "energy_export" || value === "demand_charge") {
            setShowRawJson(false);
          }
          setActiveGenTab(value);
        }}
        defaultValue="energy_import"
        className="mt-4 mb-2"
      >
        <Tabs.List position="center">
          <Tabs.Tab value="energy_import">{t("grid.tab.energyImport")}</Tabs.Tab>
          {form?.values?.componentAttributes?.gridParameters?.powerExport
            ?.condition !== "No Export" && (
            <Tabs.Tab value="energy_export">{t("grid.tab.energyExport")}</Tabs.Tab>
          )}
          <Tabs.Tab value="demand_charge">{t("grid.tab.demandCharges")}</Tabs.Tab>
        </Tabs.List>
        <Tabs.Panel value="energy_import" pt="xs">
          <Grid gutter="md" className="mt-4 mb-2">
            <Grid.Col span={12}>
              <Group position="center" align="center">
                {/* <Text>Generic Configuration</Text> */}
                <SegmentedControl
                  value={isGenabilityTimeSeriesUpload?.energy ? 'dynamic' : 'generic'}
                  onChange={(val) => handleSegmentToggleWithDataClear(setIsGenabilityTimeSeriesUpload, setDynamicGraphDataForGenability, 'energy', val)}
                  data={[
                    { label: t("grid.segmented.genericConfig"), value: 'generic' },
                    { label: t("grid.segmented.dynamicConfig"), value: 'dynamic' },
                  ]}
                  color="seGreen.0"
                />
                {/* <Text>Dynamic Configuration</Text> */}
              </Group>
            </Grid.Col>
          </Grid>
          {isGenabilityTimeSeriesUpload?.energy ? (
            <DynamicTariffImport
              importFormData={importFormData}
              handleDynamicImportChange={handleDynamicImportChange}
              dynamicGraphData={dynamicGraphDataForGenability?.energy}
              setDynamicGraphData={(data) =>
                handleDynamicGraphData(
                  setDynamicGraphDataForGenability,
                  "energy",
                  data
                )
              }
              externalErrors={importErrors}
              getFieldAttributes={getFieldAttributes}
              onChange={handleTariffChange}
            />
          ) : (
            <div className={isFullSize ? darkTheme : "chart-container-tariff"}>
               <div style={{ display: 'flex', justifyContent: 'flex-end', marginRight: "2%" }}>
              <Button
                size="xs"
                variant={showRawJson ? 'filled' : 'outline'}
                onClick={handleFetchRawTariff}
                disabled={rawLoading}
                aria-pressed={showRawJson}
              >
                {rawLoading ? 'Loading...' : 'Raw JSON'}
              </Button>
              <FontAwesomeIcon
                icon={isFullSize ? faCompress : faExpand}
                className={
                  isFullSize
                    ? "zoomed-full-size-icon-tariff"
                    : "full-size-icon-tariff"
                }
                onClick={toggleFullSize}
                style={{ marginLeft: 0 }}
              />
              </div>
              {showRawJson ? (
                <TariffRawTable raw={selectedTariffRaw} onClose={() => setShowRawJson(false)} />
              ) : (
              <Tariff
                ref={tariffRef}
                tariffTemplate={
                  selectedTariffData?.genabilityTariff?.energy?.part?.data
                    ?.schedule?.season
                }
                  isVersionCompleted={selectedVersion?.versionStatus === "COMPLETED" || selectedVersion?.versionStatus === "SIMULATED"}
                  getFieldAttributes={getFieldAttributes}
                  onChange={handleTariffChange}
              />
              )}
            </div>
          )}
        </Tabs.Panel>
        <Tabs.Panel value="energy_export" pt="xs">
          <Grid gutter="md" className="mt-4 mb-2">
            <Grid.Col span={12}>
              <Group position="center" align="center">
                {/* <Text>Generic Configuration</Text> */}
                <SegmentedControl
                  value={isGenabilityTimeSeriesUpload?.export ? 'dynamic' : 'generic'}
                  onChange={(val) => handleSegmentToggleWithDataClear(setIsGenabilityTimeSeriesUpload, setDynamicGraphDataForGenability, 'export', val)}
                  data={[
                    { label: t("grid.segmented.genericConfig"), value: 'generic' },
                    { label: t("grid.segmented.dynamicConfig"), value: 'dynamic' },
                  ]}
                  color="seGreen.0"
                />
                {/* <Text>Dynamic Configuration</Text> */}
              </Group>
            </Grid.Col>
          </Grid>
          {isGenabilityTimeSeriesUpload?.export ? (
            <DynamicTariffImport
              importFormData={importFormData}
              handleDynamicImportChange={handleDynamicImportChange}
              dynamicGraphData={dynamicGraphDataForGenability?.export}
              setDynamicGraphData={(data) =>
                handleDynamicGraphData(
                  setDynamicGraphDataForGenability,
                  "export",
                  data
                )
              }
              externalErrors={importErrors}
              getFieldAttributes={getFieldAttributes}
              onChange={handleTariffChange}
            />
          ) : (
            <div className={isFullSize ? darkTheme : "chart-container-tariff"}>
              {/* <FontAwesomeIcon
                icon={isFullSize ? faCompress : faExpand}
                className={
                  isFullSize
                    ? "zoomed-full-size-icon-tariff"
                    : "full-size-icon-tariff"
                }
                onClick={toggleFullSize}
              /> */}
              <Tariff
                ref={tariffEnergyRef}
                tariffTemplate={
                  selectedTariffData?.genabilityTariff?.export?.part?.data
                    ?.schedule?.season
                }
                  isVersionCompleted={selectedVersion?.versionStatus === "COMPLETED" || selectedVersion?.versionStatus === "SIMULATED"}
                  getFieldAttributes={getFieldAttributes}
                  onChange={handleTariffChange}
              />
            </div>
          )}
        </Tabs.Panel>
        <Tabs.Panel value="demand_charge" pt="xs">
          <div className={isFullSize ? darkTheme : "chart-container-tariff"}>
            {/* <FontAwesomeIcon
              icon={isFullSize ? faCompress : faExpand}
              className={
                isFullSize
                  ? "zoomed-full-size-icon-tariff"
                  : "full-size-icon-tariff"
              }
              onClick={toggleFullSize}
            /> */}
            <DemandCharge
              ref={dcGenabilityTariffRef}
              tariffTemplate={
                selectedTariffData?.genabilityTariff?.demandCharge?.part?.data
                  ?.schedule?.season
              }
              importTariffSeasons={
                selectedTariffData?.genabilityTariff?.energy?.part?.data
                  ?.schedule?.season || null
              }
              getImportTariffSeasons={() =>
                tariffRef?.current?.getJsonData?.() ||
                selectedTariffData?.genabilityTariff?.energy?.part?.data
                  ?.schedule?.season ||
                null
              }
              isVersionCompleted={selectedVersion?.versionStatus === "COMPLETED" || selectedVersion?.versionStatus === "SIMULATED"}
              onChange={handleTariffChange}
            />
          </div>
        </Tabs.Panel>
      </Tabs>
    );
  };

  return (
    <div ref={containerRef}>
      {/* <LoadingOverlay visible={loadingComp} overlayBlur={2} /> */}

      <SEConfirmModal
        opened={showTemplatePickerModal}
        onClose={() => { if (!templatePickerLoading) setShowTemplatePickerModal(false); }}
        header={t("grid.tariffTemplate.pickerHeader")}
        onConfirm={tariffTemplateNames?.length > 0 ? handleTemplatePickerConfirm : undefined}
        confirmLabel={t("common.ok")}
        confirmLoadingLabel={t("common.submitting")}
        confirmLoading={templatePickerLoading}
        cancelLabel={t("common.cancel")}
        onlyOk={tariffTemplateNames?.length === 0}
        size="lg"
        message={
          tariffTemplateNames?.length === 0 ? (
            <Text size="sm" color="dimmed" style={{ textAlign: 'center', padding: '1rem 0' }}>
              {t("grid.tariffTemplate.emptyMessage")}
            </Text>
          ) : (
          <div style={{ maxHeight: 400, overflowY: 'auto' }}>
            <Radio.Group
              value={templatePickerSelected}
              onChange={setTemplatePickerSelected}
              orientation="vertical"
              className="me-3"
            >
              {tariffTemplateNames.map((tmpl, idx) => (
                <div key={tmpl?.id}>
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <div style={{ flex: 1 }}>
                      <Radio
                        value={String(tmpl?.id)}
                        label={tmpl?.templateName}
                        py="xs"
                      />
                    </div>
                    <div style={{ marginLeft: 8 }}>
                      <span
                        onClick={(e) => {
                          e.stopPropagation();
                          handleDeleteTemplate(tmpl?.id);
                        }}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            e.preventDefault();
                            e.stopPropagation();
                            handleDeleteTemplate(tmpl?.id);
                          }
                        }}
                        style={{ cursor: 'pointer' }}
                        role="button"
                        aria-label={t("grid.tariffTemplate.deleteAria", { name: tmpl?.templateName })}
                      >
                        <se-icon size="sm">action_delete</se-icon>
                      </span>
                    </div>
                  </div>
                  {idx < tariffTemplateNames.length - 1 && <Divider my="xs" />}
                </div>
              ))}
            </Radio.Group>
           </div>
          )
        }
      />
        <SEConfirmModal
          opened={showDeleteTemplateModal}
          onClose={() => { if (!deleteTemplateLoading) setShowDeleteTemplateModal(false); }}
          header={t("grid.tariffTemplate.deleteHeader") || "Delete Template"}
          onConfirm={confirmDeleteTemplate}
          confirmLabel={t("common.ok")}
          confirmLoadingLabel={t("common.submitting")}
          confirmLoading={deleteTemplateLoading}
          cancelLabel={t("common.cancel")}
          size="md"
          message={
            <Text size="sm">
              {t("grid.tariffTemplate.confirmDelete", { name: deleteTemplateName }) || `Delete template ${deleteTemplateName}?`}
            </Text>
          }
        />
      <SEConfirmModal
        opened={showHelpModal}
        onClose={() => {
          resetHelpForm();
          setShowHelpModal(false);
        }}
        header={t("grid.getHelp.title", "Submit a Support Ticket")}
        onConfirm={handleHelpSubmit}
        cancelLabel={t("common.cancel")}
        confirmLabel={t("common.ok")}
        size="xl"
        confirmLoading={helpSubmitting}
        confirmLoadingLabel={t("common.submitting")}
        modalPadding="xl"
        message={
          <>
            <Select
              label={t("grid.getHelp.issueTypeLabel")}
              withAsterisk
              data={TICKET_TYPE_OPTIONS}
              value={helpForm.ticketType}
              error={helpErrors.ticketType}
              onChange={(value) => handleHelpFieldChange("ticketType", value)}
            />
            <TextInput
              label={t("grid.getHelp.titleLabel")}
              placeholder={t("grid.getHelp.titlePlaceholder")}
              withAsterisk
              minLength={5}
              maxLength={100}
              value={helpForm.ticketTitle}
              error={helpErrors.ticketTitle}
              onChange={(event) =>
                handleHelpFieldChange("ticketTitle", event.currentTarget.value)
              }
            />
            <Textarea
              placeholder={t("grid.getHelp.descriptionPlaceholder")}
              label={t("grid.getHelp.descriptionLabel")}
              withAsterisk
              minRows={10}
              value={helpForm.ticketDesc}
              error={helpErrors.ticketDesc}
              onChange={(event) =>
                handleHelpFieldChange("ticketDesc", event.currentTarget.value)
              }
            />
            <FileInput
              label={t("grid.getHelp.attachmentLabel")}
              accept="image/*"
              placeholder={t("grid.getHelp.attachmentPlaceholder")}
              value={helpForm.file}
              onChange={handleHelpFileChange}
              clearable
              rightSection={<IconFileSearch size={18} />}
              rightSectionProps={{ style: { pointerEvents: "none" } }}
            />
          </>
        }
      />
      {/* Template altered confirmation modal */}
      <SEConfirmModal
        opened={templateAlteredModalOpen}
        onClose={() => setTemplateAlteredModalOpen(false)}
        onConfirm={() => {
          setTemplateAlteredModalOpen(false);
          skipTemplateCheckRef.current = true;
          handleGridSave();
        }}
        header={t("grid.tariffTemplate.alteredHeader")}
        confirmLabel={t("common.ok")}
        cancelLabel={t("common.cancel")}
        message={
          <Text size="sm">
            {t("grid.tariffTemplate.alteredMessage")}
          </Text>
        }
      />
      {/* Template name modal */}
      <SEConfirmModal
        opened={templateNameModalOpen}
        onClose={() => { setTemplateNameModalOpen(false); setTemplateNameError(""); }}
        onConfirm={handleTemplateSaveConfirm}
        header={t("grid.tariffTemplate.modalHeader")}
        confirmLabel={t("grid.tariffTemplate.confirmLabel")}
        confirmLoadingLabel={t("grid.tariffTemplate.confirmLoadingLabel")}
        confirmLoading={templateSaveLoading}
        cancelLabel={t("common.cancel")}
        message={
          <>
            <Text size="sm" color="dimmed" mb="sm">
              {form?.values?.componentAttributes?.gridParameters?.powerExport?.condition !== "No Export"
                ? t("grid.tariffTemplate.saveInfoWithExport")
                : t("grid.tariffTemplate.saveInfoNoExport")}
            </Text>
            <TextInput
              label={t("grid.tariffTemplate.nameLabel")}
              placeholder={t("grid.tariffTemplate.namePlaceholder")}
              value={templateNameInput}
              onChange={(e) => {
                setTemplateNameInput(sanitizeText(e.target.value));
                setTemplateNameError("");
              }}
              error={templateNameError || undefined}
            />
          </>
        }
      />

      {/* Two cards with centered text */}
      {/* ...existing code... */}
      <GridPowerExchange
        projectDetails={projectDetails}
        form={form}
        handleInputChange={handleInputChange}
        gridParameters={gridParameters}
        getFieldAttributes={getFieldAttributes}
        isNewGrid={isNewGrid}
      />

      {(
        <>
          {/* <AccordionItem
            id={2}
            isVisible={true}
            openSteps={openStepB}
            header={header()}
            key={2}
            children={children()}
            height="fit-content"
          /> */}
          <AccordionItem
            id={5}
            isVisible={true}
            openSteps={openStepB}
            header={headerDefineOutage()}
            key={5}
            children={childrenDefineOutage()}
            height="fit-content"
          />
        </>
      )}
      {/* Only show the card selection step if no tariff is selected, otherwise show the selected tariff's AccordionItem */}
      {
        <AccordionItem
          id={2}
          isVisible={true}
          header={header1_1()}
          key={2}
          children={children1_1()}
          height="fit-content"
        />
      }
      <div
        ref={transitionContainerRef}
        style={{
          minHeight:
            electricityTariffSelected === "static" ||
            electricityTariffSelected === "genability"
              ? 480
              : 0,
          transition: "min-height 0.35s cubic-bezier(0.4,0,0.2,1)",
        }}
      >
        <Transition
          mounted={electricityTariffSelected === "static"}
          transition="fade"
          duration={350}
          timingFunction="ease"
        >
          {(styles) => {
            return electricityTariffSelected === "static" ? (
              <div style={styles}>
                <div ref={staticAccordionRef}>
                  <AccordionItem
                    id={3}
                    header={header2()}
                    key={3}
                    height="fit-content"
                    children={children2()}
                  />
                </div>
              </div>
            ) : null;
          }}
        </Transition>
        <Transition
          mounted={electricityTariffSelected === "genability"}
          transition="fade"
          duration={350}
          timingFunction="ease"
        >
          {(styles) => {
            return electricityTariffSelected === "genability" ? (
              <div style={styles}>
                <div ref={genAccordionRef}>
                  <AccordionItem
                    id={4}
                    header={header3()}
                    key={4}
                    children={children3()}
                    height="fit-content"
                  />
                </div>
              </div>
            ) : null;
          }}
        </Transition>
      </div>
      <div></div>
    </div>
  );
});

LoadGrid.propTypes = {
  tariffRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.any }),
  ]),
  tariffEnergyRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.any }),
  ]),
  setLoadingComp: PropTypes.func,
  tariffTouRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.any }),
  ]),
};

export default LoadGrid;
